import { render, staticRenderFns } from "./Сough.vue?vue&type=template&id=20241fdf&scoped=true&"
import script from "./Сough.vue?vue&type=script&lang=js&"
export * from "./Сough.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20241fdf",
  null
  
)

export default component.exports